<template>
  <div class='lt-scene_cupboard'>
    <SceneItemTransition :isActive="holiday === 3">
      <img
        src='../../assets/holiday-3.svg'
        class='lt-scene_cupboard_holiday'
        alt=""
      />
    </SceneItemTransition>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import SceneItemTransition from '../../components/SceneItemTransition';

export default {
  components: {
    SceneItemTransition,
  },
  computed: {
    ...mapFields([
      'scene.status.holiday',
    ]),
  },
};
</script>

<style lang='scss'>
$img-base: '../../assets';

$cupboard-height: 412;
$cupboard-width: 190;

.lt-scene_cupboard {
  position: absolute;
  right: 0;
  bottom: proportionSize(153, $scene-height);
  width: proportionSize($cupboard-width, $scene-width);
  height: proportionSize($cupboard-height, $scene-height);
  background: transparent url("#{$img-base}/cupboard.svg") no-repeat bottom right;

  .lt-scene_cupboard_holiday {
    position: absolute;
    right: 0;
    bottom: proportionSize(251, $cupboard-height);
    width: proportionSize(166, $cupboard-width);
  }
}

</style>
